import { render, staticRenderFns } from "./EducationItemCard.vue?vue&type=template&id=401d3800&scoped=true"
import script from "./EducationItemCard.vue?vue&type=script&lang=js"
export * from "./EducationItemCard.vue?vue&type=script&lang=js"
import style0 from "./EducationItemCard.vue?vue&type=style&index=0&id=401d3800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d3800",
  null
  
)

export default component.exports